import React, { useState, useEffect, useRef } from 'react';
import Select from "react-select";
import SelectSearch, { fuzzySearch } from "react-select-search";
import LeftMenu from '../LeftMenu';
import TopBar from '../TopBar';
import TopFilter from '../TopFilter';
import DatePicker from 'react-date-picker';
import 'bootstrap/dist/js/bootstrap.min.js';

import BootstrapTable from 'react-bootstrap-table-next';
import Breadcrumbs from '../Breadcrumbs';
import paginationFactory from 'react-bootstrap-table2-paginator';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import filterFactory, { textFilter, customFilter } from 'react-bootstrap-table2-filter';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';
import PropTypes from 'prop-types';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import '../../style/custom.css';
import moment from 'moment';
import { formatInputDate, toLocalDate, getValidNumericValue } from '../Utlities';
import LocationManager from './LocationManager';

export default function AccServicesContractManagement({ sccData, onUpdateGridData, selectedCust }) {
    const [gridData, setGridData] = useState([]);
    const [cust, setCust] = useState(0);


    const generateNewRow = () => {
        const username = sessionStorage.getItem('my-username');
        const timestamp = new Date().getTime().toString(); // Use current timestamp as string

        return {
            id: timestamp, // Unique ID based on timestamp
            checked: false,
            customerKey: cust,
            terminationDateValue: null,
            terminationDate: null,
            customerSignedDateValue: null,
            customerSignedDate: null,
            contractSignedDateValue: null,
            contractSignedDate: null,
            contractEffectiveDateValue: null,
            contractEffectiveDate: null,
            contractExpirationeDateValue: null,
            contractExpirationeDate: null,
            contractTerms: null,
            autoRenewal: "Y",
            renewalTerms: null,
            autoRenewalDateValue: null,
            autoRenewalDate: null,
            notificationEmails: "",
            serviceType: "CM",
            createdBy: username,
            dirtyFlag: 'I',
            isNew: true
        };
    };

    const handleAddRow = () => {
        const newRow = generateNewRow();
        setGridData([...gridData, newRow]);
    };

    useEffect(() => {
        debugger;
        setCust(selectedCust);
        if (Array.isArray(sccData)) {
            // debugger;
            const filteredNvisionServices = sccData.filter(
                service => service.serviceType === "CM"
            );
            // Map the filtered services
            const updatedNvisionServices = filteredNvisionServices.map(service => ({
                ...service,
                contractEffectiveDateValue: toLocalDate(service.contractEffectiveDate),
                terminationDateValue: toLocalDate(service.terminationDate),
                customerSignedDateValue: toLocalDate(service.customerSignedDate),
                contractSignedDateValue: toLocalDate(service.contractSignedDate),
                contractEffectiveDateValue: toLocalDate(service.contractEffectiveDate),
                contractExpirationeDateValue: toLocalDate(service.contractExpirationeDate),
                autoRenewalDateValue: toLocalDate(service.autoRenewalDate)
            }));
            setGridData(updatedNvisionServices);

            const autoRenewalValues = filteredNvisionServices.map(
                service => service.autoRenewal
            );
            setIsAutoRenewDisabled(!autoRenewalValues.includes("Y") && autoRenewalValues.length > 0);
            setIsRenewTermsDisabled(!autoRenewalValues.includes("Y") && autoRenewalValues.length > 0);
            // console.log(filteredNvisionServices);
        } else {
            setGridData([]);
        }
        // debugger;
    }, [sccData]);

    useEffect(() => {
        onUpdateGridData(gridData);
    }, [gridData]);


    const handleDateOfTerminationChange = (newDate, row) => {
        debugger;
        if (!row) {
            handleAddRow();
        }

        setGridData(gridData => {
            const updatedData = gridData.map(item => {
                debugger;

                // Check if newDate is null
                let isDateChanged = newDate !== null && item.terminationDate !== moment(newDate).format().substring(0, 10);

                if (newDate === null) {
                    isDateChanged = true;
                }

                let dirtyFlag = item.dirtyFlag;

                if (item.isNew && isDateChanged) {
                    dirtyFlag = 'I';
                } else if (isDateChanged) {
                    dirtyFlag = 'U';
                }

                debugger;
                return {
                    ...item,
                    // terminationDate: newDate !== null ? moment(newDate).format().substring(0, 10) : null, // Update terminationDate accordingly
                    terminationDateValue: newDate,
                    terminationDate: formatInputDate(newDate),
                    dirtyFlag: dirtyFlag,
                    modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username') // Update modifiedBy for existing rows
                };
            });

            // Update data immediately and notify parent component
            setGridData(updatedData);
            onUpdateGridData(updatedData);
            console.log(updatedData);
            return updatedData;
        });
    };


    const handleDateOfCustomerSignChange = (newDate, row) => {
        debugger;
        if (!row) {
            handleAddRow();
        }

        setGridData(gridData => {
            const updatedData = gridData.map(item => {
                debugger;

                // Check if newDate is null
                let isDateChanged = newDate !== null && item.customerSignedDate !== moment(newDate).format().substring(0, 10);

                if (newDate === null) {
                    isDateChanged = true;
                }

                let dirtyFlag = item.dirtyFlag;

                if (item.isNew && isDateChanged) {
                    dirtyFlag = 'I';
                } else if (isDateChanged) {
                    dirtyFlag = 'U';
                }
                return {
                    ...item,
                    // customerSignedDate: newDate !== null ? moment(newDate).format().substring(0, 10) : null,
                    customerSignedDateValue: newDate,
                    customerSignedDate: formatInputDate(newDate),
                    dirtyFlag: dirtyFlag,
                    modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username') // Update modifiedBy for existing rows
                };
            });

            // Update data immediately and notify parent component
            setGridData(updatedData);
            onUpdateGridData(updatedData);
            console.log(updatedData);
            return updatedData;
        });
    };

    const handleDateOfContractSignChange = (newDate, row) => {
        if (!row) {
            handleAddRow();
        }

        setGridData(gridData => {
            const updatedData = gridData.map(item => {

                // Check if newDate is null
                let isDateChanged = newDate !== null && item.contractSignedDate !== moment(newDate).format().substring(0, 10);

                if (newDate === null) {
                    isDateChanged = true;
                }

                let dirtyFlag = item.dirtyFlag;

                if (item.isNew && isDateChanged) {
                    dirtyFlag = 'I';
                } else if (isDateChanged) {
                    dirtyFlag = 'U';
                }
                return {
                    ...item,
                    // contractSignedDate: newDate !== null ? moment(newDate).format().substring(0, 10) : null,
                    contractSignedDateValue: newDate,
                    contractSignedDate: formatInputDate(newDate),
                    dirtyFlag: dirtyFlag,
                    modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username') // Update modifiedBy for existing rows
                };
            });

            // Update data immediately and notify parent component
            setGridData(updatedData);
            onUpdateGridData(updatedData);
            return updatedData;
        });
    };

    const handleDateOfContractEffectiveChange = (newDate, row) => {
        if (!row) {
            handleAddRow();
        }

        setGridData(gridData => {
            const updatedData = gridData.map(item => {

                // Check if newDate is null
                let isDateChanged = newDate !== null && item.contractEffectiveDate !== moment(newDate).format().substring(0, 10);

                if (newDate === null) {
                    isDateChanged = true;
                }

                let dirtyFlag = item.dirtyFlag;

                if (item.isNew && isDateChanged) {
                    dirtyFlag = 'I';
                } else if (isDateChanged) {
                    dirtyFlag = 'U';
                }
                return {
                    ...item,
                    // contractEffectiveDate: newDate !== null ? moment(newDate).format().substring(0, 10) : null,
                    contractEffectiveDateValue: newDate,
                    contractEffectiveDate: formatInputDate(newDate),
                    dirtyFlag: dirtyFlag,
                    modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username') // Update modifiedBy for existing rows
                };
            });

            // Update data immediately and notify parent component
            setGridData(updatedData);
            onUpdateGridData(updatedData);
            return updatedData;
        });
    };

    const handleDateOfContractExpirationChange = (newDate, row) => {
        debugger;
        if (!row) {
            handleAddRow();
        }

        setGridData(gridData => {
            const updatedData = gridData.map(item => {

                // Check if newDate is null
                let isDateChanged = newDate !== null && item.contractExpirationeDate !== moment(newDate).format().substring(0, 10);

                if (newDate === null) {
                    isDateChanged = true;
                }

                let dirtyFlag = item.dirtyFlag;

                if (item.isNew && isDateChanged) {
                    dirtyFlag = 'I';
                } else if (isDateChanged) {
                    dirtyFlag = 'U';
                }

                debugger;
                // Calculate autoRenewDate
                const expirationDate = new Date(newDate);
                const renewTerm = parseInt(item.renewalTerms || '0', 10); // Parse renewalTerms as integer, default to 0 if it's not set
                const autoRenewDate = new Date(expirationDate.getFullYear() + renewTerm, expirationDate.getMonth(), expirationDate.getDate());


                return {
                    ...item,
                    // contractExpirationeDate: newDate !== null ? moment(newDate).format().substring(0, 10) : null,
                    // autoRenewalDate: moment(autoRenewDate).format().substring(0, 10),
                    contractExpirationeDateValue: newDate,
                    contractExpirationeDate: formatInputDate(newDate),
                    autoRenewalDateValue: autoRenewDate,
                    autoRenewalDate: formatInputDate(autoRenewDate),
                    dirtyFlag: dirtyFlag,
                    modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username') // Update modifiedBy for existing rows
                };
            });

            // Update data immediately and notify parent component
            setGridData(updatedData);
            onUpdateGridData(updatedData);
            return updatedData;
        });
    };

    const handleDateOfAutoRenewalChange = (newDate, row) => {
        if (!row) {
            handleAddRow();
        }

        setGridData(gridData => {
            const updatedData = gridData.map(item => {

                // Check if newDate is null
                let isDateChanged = newDate !== null && item.autoRenewalDate !== moment(newDate).format().substring(0, 10);

                if (newDate === null) {
                    isDateChanged = true;
                }

                let dirtyFlag = item.dirtyFlag;

                if (item.isNew && isDateChanged) {
                    dirtyFlag = 'I';
                } else if (isDateChanged) {
                    dirtyFlag = 'U';
                }
                return {
                    ...item,
                    autoRenewalDateValue: newDate,
                    autoRenewalDate: formatInputDate(newDate),
                    dirtyFlag: dirtyFlag,
                    modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username') // Update modifiedBy for existing rows
                };
            });

            // Update data immediately and notify parent component
            setGridData(updatedData);
            onUpdateGridData(updatedData);
            return updatedData;
        });
    };

    const handleContractTermTextChange = (newValue, row) => {
        debugger;
        if (!row) {
            handleAddRow();
        }

        // Filter out non-numeric characters
        const numericValue = getValidNumericValue(newValue);

        setGridData((gridData) => {
            const updatedData = gridData.map((item) => {
                debugger;
                const isTextChanged = item.contractTerms !== numericValue;

                let dirtyFlag = item.dirtyFlag;

                if (item.isNew && isTextChanged) {
                    dirtyFlag = 'I';
                } else if (isTextChanged) {
                    dirtyFlag = 'U';
                }

                return {
                    ...item,
                    contractTerms: numericValue,
                    dirtyFlag: dirtyFlag,
                    modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username'),
                };
            });

            // Update data immediately and notify the parent component
            setGridData(updatedData);
            onUpdateGridData(updatedData);
            return updatedData;
        });
    };


    const [renewTermValue, setRenewTermValue] = useState("");
    const [isAutoRenewDisabled, setIsAutoRenewDisabled] = useState(false);
    const [isRenewTermsDisabled, setIsRenewTermsDisabled] = useState(false);


    const datePickerRef = useRef(null);

    // Function to clear the DatePicker value
    const clearDatePickerValue = () => {
        if (datePickerRef.current) {
            datePickerRef.current.clear();
        }
    };

    const handleAutoRenewalChange = (newValue, row) => {
        debugger;
        if (!row) {
            handleAddRow();
        }

        const isAutoRenewalN = newValue === 'N';
        if (isAutoRenewalN) {
            setRenewTermValue("0");
            debugger;
            clearDatePickerValue();
            setIsAutoRenewDisabled(true);
            setIsRenewTermsDisabled(true);

        } else {
            setRenewTermValue("");
            document.getElementById('renewterm').disabled = false;
            setIsAutoRenewDisabled(false);
            setIsRenewTermsDisabled(false);
        }

        let renewalTerms = isAutoRenewalN ? '0' : ''; // Set renewalTerms to '0' if autoRenewal is 'N',

        setGridData(gridData => {
            const updatedData = gridData.map(item => {
                const isAutoRenewal = item.autoRenewal !== newValue;

                let dirtyFlag = item.dirtyFlag;

                if (item.isNew && isAutoRenewal) {
                    dirtyFlag = 'I';
                } else if (isAutoRenewal) {
                    dirtyFlag = 'U';
                }
                return {
                    ...item,
                    renewalTerms: renewalTerms,
                    autoRenewal: newValue,
                    dirtyFlag: dirtyFlag,
                    modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username') // Update modifiedBy for existing rows
                };
            });

            // Disable renewterm if autoRenewal is 'N'

            // Update data immediately and notify parent component
            setGridData(updatedData);
            onUpdateGridData(updatedData);
            return updatedData;
        });
    };

    const handleRenewalTermTextChange = (newValue, row) => {
        if (!row) {
            handleAddRow();
        }

        // Filter out non-numeric characters and allow up to 2 digits
        const numericValue = getValidNumericValue(newValue);
        setRenewTermValue(numericValue);

        setGridData(gridData => {
            const updatedData = gridData.map(item => {
                const isTextChanged = item.renewalTerms !== numericValue;

                let dirtyFlag = item.dirtyFlag;

                if (item.isNew && isTextChanged) {
                    dirtyFlag = 'I';
                } else if (isTextChanged) {
                    dirtyFlag = 'U';
                }

                // Calculate autoRenewDate
                const expirationDate = new Date(item.contractExpirationeDateValue);
                const renewTerm = parseInt(numericValue || '0', 10); // Parse numericValue as integer, default to 0 if it's not set
                const autoRenewDate = new Date(expirationDate.getFullYear() + renewTerm, expirationDate.getMonth(), expirationDate.getDate());

                return {
                    ...item,
                    renewalTerms: numericValue,
                    autoRenewalDateValue: autoRenewDate,
                    autoRenewalDate: formatInputDate(autoRenewDate),
                    // autoRenewalDate: moment(autoRenewDate).format().substring(0, 10), // Set autoRenewDate
                    dirtyFlag: dirtyFlag,
                    modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username'),
                };
            });

            // Update data immediately and notify parent component
            setGridData(updatedData);
            onUpdateGridData(updatedData);
            return updatedData;
        });
    };

    // Helper function to filter out non-numeric characters and allow up to 2 digits
    // const getValidNumericValue = (value) => {
    //     return value.replace(/\D/g, '').substring(0, 2);
    // };


    const handleNotificationTextChange = (newValue, row) => {
        if (!row) {
            handleAddRow();
        }

        setGridData(gridData => {
            const updatedData = gridData.map(item => {
                const isTextChanged = item.notificationEmails !== newValue;

                let dirtyFlag = item.dirtyFlag;

                if (item.isNew && isTextChanged) {
                    dirtyFlag = 'I';
                } else if (isTextChanged) {
                    dirtyFlag = 'U';
                }

                return {
                    ...item,
                    notificationEmails: newValue,
                    dirtyFlag: dirtyFlag,
                    modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username') // Update modifiedBy for existing rows
                    // modifiedOn: item.isNew ? '' : new Date().toISOString() // Update modifiedOn for existing rows
                };
            });

            // Update data immediately and notify parent component
            setGridData(updatedData);
            onUpdateGridData(updatedData);
            return updatedData;
        });
    };

    return (
        <div className="accordion-item">
            <h2 className="accordion-header" id="headingEight">
                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEight" aria-expanded="true" aria-controls="collapseEight">
                    Services and Contract Management
                </button>
            </h2>
            <div id="collapseEight" className="accordion-collapse collapse show" aria-labelledby="headingEight" data-bs-parent="#accordionSettings">
                <div className="accordion-body">
                    <div className='row'>
                        <LocationManager row={gridData[0]} handleAddRow={handleAddRow} cust={cust} setGridData={setGridData} gridData={gridData} onUpdateGridData={onUpdateGridData} />
                    </div>
                    <div className='row'>
                        <div className='col-4 col-xs-12'>
                            <div className='row g-0 mb-2'>
                                <div className='col-md-8 col-xs-12'>
                                    <label>Termination Date</label>
                                </div>
                                <div className='col-md-4 col-xs-12'>
                                    <DatePicker
                                        // value={gridData.length > 0 ? (gridData[0].terminationDate !== null ? new Date(gridData[0].terminationDate) : null) : null}
                                        value={gridData.length > 0 ? gridData[0].terminationDateValue : null}
                                        onChange={newDate => handleDateOfTerminationChange(newDate, gridData[0])}
                                        calendarIcon={<i className='fas fa-calendar-alt'></i>}
                                        format="MM/dd/yyyy"
                                        fixedHeight
                                        openCalendarOnFocus={false}
                                    />
                                </div>
                            </div>

                            <div className='row g-0 mb-2'>
                                <div className='col-md-8 col-xs-12'>
                                    <label>Contract Signed Date (Customer)</label>
                                </div>
                                <div className='col-md-4 col-xs-12'>
                                    <DatePicker
                                        // value={gridData.length > 0 ? (gridData[0].customerSignedDate !== null ? new Date(gridData[0].customerSignedDate) : null) : null}
                                        value={gridData.length > 0 ? gridData[0].customerSignedDateValue : null}
                                        onChange={newDate => handleDateOfCustomerSignChange(newDate, gridData[0])}
                                        calendarIcon={<i className='fas fa-calendar-alt'></i>}
                                        format="MM/dd/yyyy"
                                        fixedHeight
                                        openCalendarOnFocus={false}
                                    />
                                </div>
                            </div>

                            <div className='row g-0'>
                                <div className='col-md-8 col-xs-12'>
                                    <label>Contract Signed Date (nVision Global)</label>
                                </div>
                                <div className='col-md-4 col-xs-12'>
                                    <DatePicker
                                        value={gridData.length > 0 ? gridData[0].contractSignedDateValue : null}
                                        onChange={newDate => handleDateOfContractSignChange(newDate, gridData[0])}
                                        calendarIcon={<i className='fas fa-calendar-alt'></i>}
                                        format="MM/dd/yyyy"
                                        fixedHeight
                                        openCalendarOnFocus={false}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-4 col-xs-12 ps-4 pe-0'>
                            <div className='row mb-2'>
                                <div className='col-md-6 col-xs-12'>
                                    <label>Contract Effective Date</label>
                                    <label className="text-danger">*</label>
                                </div>
                                <div className='col-md-6 col-xs-12'>
                                    <DatePicker
                                        // value={gridData.length > 0 ? toLocalDate(gridData[0].contractEffectiveDate) : null}
                                        value={gridData.length > 0 ? gridData[0].contractEffectiveDateValue : null}
                                        onChange={newDate => handleDateOfContractEffectiveChange(newDate, gridData[0])}
                                        calendarIcon={<i className='fas fa-calendar-alt'></i>}
                                        format="MM/dd/yyyy"
                                        fixedHeight
                                        openCalendarOnFocus={false}
                                    />
                                </div>
                            </div>
                            <div className='row mb-2'>
                                <div className='col-md-6 col-xs-12'>
                                    <label>Contract Expiration Date</label>
                                    <label className="text-danger">*</label>
                                </div>
                                <div className='col-md-6 col-xs-12'>
                                    <DatePicker
                                        id="expirationDate"
                                        value={gridData.length > 0 ? gridData[0].contractExpirationeDateValue : null}
                                        onChange={newDate => handleDateOfContractExpirationChange(newDate, gridData[0])}
                                        calendarIcon={<i className='fas fa-calendar-alt'></i>}
                                        format="MM/dd/yyyy"
                                        fixedHeight
                                        openCalendarOnFocus={false}
                                    />
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-6 col-xs-12'>
                                    <label>Contract Term</label>
                                    <label className="text-danger">*</label>
                                </div>
                                <div className='col-md-4 col-xs-12'>
                                    <input id="contractterm"
                                        value={gridData.length > 0 ? (gridData[0].contractTerms !== "" ? gridData[0].contractTerms : "") : ""}
                                        className="form-control form-control-sm"
                                        onChange={e => handleContractTermTextChange(e.target.value, gridData[0])}>
                                    </input>
                                </div>
                                <div className='col-md-2 col-xs-12 px-0 mt-1'>
                                    <span><b> Year(s)</b></span>
                                </div>
                            </div>
                        </div>
                        <div className='col-4 col-xs-12 ps-5'>
                            <div className='row mb-2'>
                                <div className='col-md-6 col-xs-12'>
                                    <label>Auto-Renewed?</label>
                                </div>
                                <div className='col-md-6 col-xs-12'>
                                    <div className="form-check form-check-inline">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="inlineRadioOptions"
                                            checked={gridData.length > 0 ? gridData[0].autoRenewal === "Y" : true} // Set default value to true if autoRenewal is not defined
                                            onChange={e => handleAutoRenewalChange(e.target.value, gridData[0])}
                                            id="inlineRadio1"
                                            value="Y"
                                        />
                                        <label className="form-check-label" for="inlineRadio1">Yes</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="inlineRadioOptions"
                                            checked={gridData.length > 0 ? gridData[0].autoRenewal === "N" : false}
                                            onChange={e => handleAutoRenewalChange(e.target.value, gridData[0])}
                                            id="inlineRadio2"
                                            value="N"
                                        />
                                        <label className="form-check-label" for="inlineRadio2">No</label>
                                    </div>
                                </div>
                            </div>

                            <div className='row mb-2'>
                                <div className='col-md-6 col-xs-12'>
                                    <label>Terms of Renewal</label>
                                </div>
                                <div className='col-md-4 col-xs-12'>
                                    <input id="renewterm"
                                        value={gridData.length > 0 ? (gridData[0].renewalTerms !== "" ? gridData[0].renewalTerms : "") : ""}
                                        className="form-control form-control-sm"
                                        onChange={e => handleRenewalTermTextChange(e.target.value, gridData[0])}
                                        disabled={isRenewTermsDisabled}
                                    >
                                    </input>
                                </div>
                                <div className='col-md-2 col-xs-12 px-0 mt-1'>
                                    <span><b> Year(s)</b></span>
                                </div>

                            </div>

                            <div className='row'>
                                <div className='col-md-6 col-xs-12'>
                                    <label>Auto-Renew Date</label>
                                </div>
                                <div className='col-md-6 col-xs-12'>
                                    <DatePicker
                                        ref={datePickerRef}
                                        id="autoRenewDate"
                                        value={gridData.length > 0 ? gridData[0].autoRenewalDateValue : null}
                                        onChange={newDate => handleDateOfAutoRenewalChange(newDate, gridData[0])}
                                        calendarIcon={<i className='fas fa-calendar-alt'></i>}
                                        format="MM/dd/yyyy"
                                        fixedHeight
                                        openCalendarOnFocus={false}
                                        disabled={isAutoRenewDisabled}
                                    />
                                </div>
                            </div>

                        </div>

                    </div>
                    <div className='row'>

                        <div className='col-md-12'>
                            <div className='row g-0 mt-2'>
                                <div className='col-md-2 col-xs-12'>
                                    <label>Notification Email of Auto-Renewal
                                        <label className="text-danger">*</label>
                                    </label>

                                </div>
                                <div className='col-md-10 col-xs-12' style={{ paddingLeft: '50px' }}>
                                    <input id="email"
                                        value={gridData.length > 0 ? (gridData[0].notificationEmails !== "" ? gridData[0].notificationEmails : "") : ""}
                                        className="form-control form-control-sm"
                                        onChange={e => handleNotificationTextChange(e.target.value, gridData[0])}>
                                    </input>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

